<pannel [title]="'Entreprise utilisatrice (EU)'" *ngIf="order">
<div class="form-group row">
	<label class="control-label col-md-1">Entreprise référente*</label>
	<div class="col-md-3">
		<input id="entrepriseReferente" type="text" class="form-control" [(ngModel)]="entrepriseReferenteNom" [readonly]="true" />

	</div>

	<label class="control-label col-md-1">SPV-Parc*</label>
	<div class="col-md-3" [ngClass]="{'highlightable': !isRaisonSocialeEuFilled}">
		<input id="raisonSocialeId" type="text" class="form-control"
			[(ngModel)]="order.raisonSocialeEu"
			(ngModelChange)="onRaisonSocialeEuChange($event); evaluerFormulaire()"
			[disabled]="currentPaValue | disablePaField" />
	</div>
</div>

<div class="form-group row">
	<label class="control-label col-md-1">Adresse</label>
	<div class="col-md-3">
		<input id="adresseEu" type="text" class="form-control"
			[(ngModel)]="order.adresseEntrepriseEu" [disabled]="currentPaValue | disablePaField"/>
	</div>
</div>

<p>
	<b>Représentant / Responsable sur site :</b>
</p>

<div class="form-group row">
	<label class="control-label col-md-1">Nom, Prénom*</label>
	<div class="col-md-3"
		[ngClass]="{'highlightable': !isResponsableEuFilled}">
		<input id="nomEu" type="text" class="form-control"
			[(ngModel)]="order.nomPrenomResponsableEu" [readonly]="true" />
	</div>

	<label class="control-label col-md-1">Email*</label>
	<div class="col-md-3" [ngClass]="{'highlightable': !isEmailEuFilled}">
		<input id="emailEu" type="text" class="form-control"
			[(ngModel)]="order.emailResponsableEu" 
			(ngModelChange)="onEuEmailChange(); evaluerFormulaire()" [disabled]="currentPaValue | disablePaField" />
	</div>
</div>

<div class="form-group row">
	<label class="control-label col-md-1">Fonction</label>
	<div class="col-md-3">
		<input id="fonctionEu" type="text" class="form-control"
			[(ngModel)]="order.fonctionResponsableEu" [disabled]="currentPaValue | disablePaField" />
	</div>

	<label class="control-label col-md-1">Téléphone</label>
	<div class="col-md-1">
		<filterable-select
			[inputClass]="'form-control'" 
			[list]="indicatifTelephoneOptions"
			[labelGetter]="getIndicatifLabel"
			[selectedItem]="getSelectedIndicatifEu()"
			(selectedItemChange)="onEuIndicatifChange($event)" [disabled]="currentPaValue | disablePaField">
		</filterable-select>
	</div>
	<div class="col-md-2">
		<input id="phoneEu" type="tel" class="form-control"
			[(ngModel)]="order.phoneResponsableEu"
			(ngModelChange)="onEuPhoneChange()" [disabled]="currentPaValue | disablePaField" />
	</div>
</div>

<div class="form-group row">
	<label for="astreinte" class="control-label col-md-1">Astreinte</label>
	<div class="col-md-3">
		<multi-editable-filterable-select
			[id]="'antenneAstreintes'"
			[labelGetter]="getNumeroAstreinteLabel"
			[initCommand]="initAstreinteCommand"
			[suggestionsCommand]="numeroAstreintesCommand"
			[existingValuesCommand]="existingAstreintesCommand"
			[placeholder]="'Saisir un numéro d\'astreinte'"
			(selectedItemsChange)="onNumeroAstreinteSelected($event)">
		</multi-editable-filterable-select>
	</div>
</div>
</pannel>

<!-- ------------------EE------------------ -->
<pannel [title]="'Entreprise extérieure (EE)'" *ngIf="order">
<div class="form-group row">
	<label class="control-label col-md-1">Entreprise Extérieure*</label>
	<div class="col-md-3"
		[ngClass]="{'highlightable': !isEntrepriseExterieureFilled}">
		<filterable-select id="entrepriseEe" [inputClass]="'form-control'"
			[list]="filteredEntreprisesEe" [labelGetter]="getEntrepriseLabel"
			[selectedItem]="selectedEntrepriseEe"
			(selectedItemChange)="onSelectEntrepriseEe($event || null); evaluerFormulaire()"
			(cleared)="onClearEntrepriseEe()" [disabled]="currentPaValue | disablePaField"> </filterable-select>

	</div>

	<label class="control-label col-md-1">Raison sociale</label>
	<div class="col-md-3">
		<input id="raisonSocialeEe" type="text" class="form-control"
			[(ngModel)]="order.raisonSocialeEe"
			[disabled]="currentPaValue | disablePaField" />
	</div>
</div>

<div class="form-group row">
	<label class="control-label col-md-1">Adresse</label>
	<div class="col-md-3">
		<input id="adresseEe" type="text" class="form-control"
			[(ngModel)]="order.adresseEntrepriseEe"
			[disabled]="currentPaValue | disablePaField" />
	</div>
</div>

<p>
	<b>Représentant / Responsable sur site :</b>
</p>

<div class="form-group row">
	<label class="control-label col-md-1">Nom, Prénom*</label>
	<div class="col-md-3" [ngClass]="{'highlightable': !isResponsableEeFilled}">
		<filterable-select id="intervenantEe" [inputClass]="'form-control'"
			[list]="filteredIntervenantsEe" [labelGetter]="getIntervenantLabel"
			[selectedItem]="selectedIntervenantEe"
			(selectedItemChange)="onSelectIntervenantEe($event) ; evaluerFormulaire()"
			(ngModelChange)="evaluerFormulaire()" [disabled]="currentPaValue | disablePaField"> </filterable-select>
	</div>

	<label class="control-label col-md-1">Email</label>
	<div class="col-md-3">
		<input id="emailEe" type="text" class="form-control"
			[(ngModel)]="order.emailResponsableEe"
			[readonly]="!selectedIntervenantEe"
			[disabled]="currentPaValue | disablePaField"
			(ngModelChange)="evaluerFormulaire(); onEeEmailChange()" />
	</div>
</div>

<div class="form-group row">
	<label class="control-label col-md-1">Fonction</label>
	<div class="col-md-3">
		<input id="fonctionEe" type="text" class="form-control"
			[(ngModel)]="order.fonctionResponsableEe"
			[readonly]="!selectedIntervenantEe"
			[disabled]="currentPaValue | disablePaField" />
	</div>

	<label class="control-label col-md-1">Téléphone</label>
	<div class="col-md-1">
		<filterable-select
			[inputClass]="'form-control'" 
			[list]="indicatifTelephoneOptions"
			[labelGetter]="getIndicatifLabel"
			[selectedItem]="getSelectedIndicatifEe()"
			(selectedItemChange)="onEeIndicatifChange($event)" [disabled]="currentPaValue | disablePaField">
		</filterable-select>
	</div>
	<div class="col-md-2">
		<input id="phoneEe" type="tel" class="form-control"
			[(ngModel)]="order.phoneResponsableEe"
			[readonly]="!selectedIntervenantEe"
			[disabled]="currentPaValue | disablePaField" 
			(ngModelChange)="onEePhoneChange()" />
	</div>
</div>
</pannel>

<document-pa-step-actions [documentPaButtons]="actionButtons" (onButtonPressed)="performAction($event)"></document-pa-step-actions>